// String.fromCharCode(code) for a single code, written with String.fromCodePoint (PLAY-5325, S7758).
// fromCharCode reduces its argument with ToUint16: NaN and Infinity become 0, fractions are
// truncated and everything else wraps modulo 2^16. `Number(code) & 0xffff` performs that same
// reduction, so the result is identical for every input and fromCodePoint never sees a value it
// would throw on. The currency symbol codes come from the API (decimal numbers, "0x..." strings
// or a parsed hex string that can be NaN), so they can't be assumed to be valid code points.
export function charFromCode(code: unknown): string {
  return String.fromCodePoint(Number(code) & 0xffff);
}
